import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';

const Nav = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 60px;
  background: ${({ isScrolled }) =>
    isScrolled
      ? 'linear-gradient(to bottom, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.7) 100%)'
      : 'transparent'};
  transition: all 0.3s ease;
  z-index: 1000;
`;

const Logo = styled(Link)`
  color: #e50914;
  font-size: 2rem;
  font-weight: bold;
  text-decoration: none;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 20px;
`;

const NavLink = styled(Link)`
  color: white;
  font-size: 1rem;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    color: #b3b3b3;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 0;
    height: 2px;
    background-color: #e50914;
    transition: width 0.3s ease;
  }

  &:hover::after {
    width: 100%;
  }
`;

const SearchContainer = styled.div`
  position: relative;
  margin: 0 20px;
`;

const SearchInput = styled.input`
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 4px;
  color: white;
  padding: 8px 12px;
  width: 200px;
  font-size: 0.9rem;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    background-color: rgba(255, 255, 255, 0.2);
    width: 250px;
  }

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
`;

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery('');
    }
  };

  return (
    <Nav isScrolled={isScrolled}>
      <Logo to="/">MOVIESITE</Logo>
      <NavLinks>
        <NavLink to="/">Home</NavLink>
        <NavLink to="/?category=movies">Movies</NavLink>
        <NavLink to="/?category=series">TV Shows</NavLink>
        <SearchContainer>
          <form onSubmit={handleSearch}>
            <SearchInput
              type="text"
              placeholder="Search movies & TV shows..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </form>
        </SearchContainer>
      </NavLinks>
    </Nav>
  );
};

export default Navbar; 